(() =>
{
	let autoGrowEls = [...document.querySelectorAll('.auto-grow')];

	const expandSection = el =>
	{
		let sectionHeight = el.scrollHeight;

		const transitionEndListener = () => 
		{
			el.removeEventListener('transitionend', transitionEndListener);
			el.style.height = null;
		};

		el.style.height = `${sectionHeight}px`;
		el.addEventListener('transitionend', transitionEndListener);
		el.setAttribute('data-collapsed', false);
	};

	const collapseSection = el =>
	{
		let sectionHeight = el.scrollHeight;
		let elTransition = el.style.transition;
		const defaultsize = (el.dataset.teaserheight) ? `${el.dataset.teaserheight}px` : 0;
		el.style.transition = '';

		requestAnimationFrame(() =>
		{
			el.style.height = `${sectionHeight}px`;
			el.style.transition = elTransition;

			requestAnimationFrame(() =>
			{
				el.style.height = defaultsize;
			});
		});

		el.setAttribute('data-collapsed', true);
	};
	autoGrowEls.forEach(el =>
	{
		// el.parentElement should be a wrapping container
		let autoGrowTargetEl = el.parentElement.querySelector('.auto-grow-target');

		const itemHeight = autoGrowTargetEl.querySelector('.products-module');
		if(itemHeight) {
			autoGrowTargetEl.dataset.teaserheight = itemHeight.offsetHeight * 1.4;
		}

		if (autoGrowTargetEl.getAttribute('data-collapsed') === 'true')
		{
			collapseSection(autoGrowTargetEl);
		}

		el.addEventListener('click', () =>
		{
			let isCollapsed = autoGrowTargetEl.getAttribute('data-collapsed') === 'true';

			if (isCollapsed)
			{
				expandSection(autoGrowTargetEl);
				el.classList.add('auto-grow--open');
				autoGrowTargetEl.classList.add('auto-grow-target--open');
			} else
			{
				collapseSection(autoGrowTargetEl);
				el.classList.remove('auto-grow--open');
				autoGrowTargetEl.classList.remove('auto-grow-target--open');
			}
		});
	});
})();